export default __webpack_public_path__ + "static/title-news-en-9a3d4ed136be5760fb85c737c855d4f6.png";